import React from 'react'
import './AfiliacionesMembresias.css'

// Importa tus imágenes (ejemplo)
import afiliacion1 from '../assets/images/membership-1.png'
import afiliacion2 from '../assets/images/membership-2.png'
import afiliacion3 from '../assets/images/membership-3.png'
import afiliacion4 from '../assets/images/membership-4.png'
import afiliacion5 from '../assets/images/membership-5.png'

const AfiliacionesMembresias = () => {
  const afiliaciones = [
    { id: 1, img: afiliacion1, alt: 'Sociedad Chilena de Endocrinología' },
    { id: 2, img: afiliacion2, alt: 'Sociedad de Diabetes Latinoamericana' },
    { id: 3, img: afiliacion3, alt: 'Asociación Médica Internacional' },
    { id: 4, img: afiliacion4, alt: 'Colegio Médico de Chile' },
    { id: 5, img: afiliacion5, alt: 'Universidad de Chile' },
  ]

  return (
    <section className="afiliaciones-container" id="testimonios">
      <h2>Afiliaciones y Membresías</h2>

      <div className="afiliaciones-grid">
        {afiliaciones.map((item) => (
          <div className="afiliacion-item" key={item.id}>
            <img src={item.img} alt={item.alt} />
          </div>
        ))}
      </div>
    </section>
  )
}

export default AfiliacionesMembresias
